import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/landing-page";
import Pricing from "./pages/pricing/pricing";
import About from "./pages/about/about";
import Portfolio from "./pages/portfolio/portfolio";
import UseCases from "./pages/use-cases/use-cases";
import ArticleDetail from "./pages/use-cases/ArticleDetail";
import HowWeWork from "./pages/how-we-work/how-we-work";
import Faq from "./pages/faq/faq";
import PermissionsTermsPrivacy from "./pages/permissions-terms-privacy/permissions-terms-privacy";
import Policy from "./pages/policy/policy";
import AiDiagnostic from "./pages/ai-diagnostic/ai-diagnostic";
import Navbar from "./component/navbar/navbar";
import Footer from "./component/footer/footer";
import { LanguageProvider } from "./i18n/LanguageContext";
import "./index.css";

// Component to scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  // Navbar sudah fixed position, tidak perlu mendorong content
  const handleNavToggle = () => {
    // No action needed - navbar is fixed positioned
  };

  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <Navbar onToggle={handleNavToggle} />

        <main>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/permissions-terms-privacy" element={<PermissionsTermsPrivacy />} />
            <Route path="/policy" element={<Policy />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/use-cases" element={<UseCases />} />
            <Route path="/use-cases/:id" element={<ArticleDetail />} />
            <Route path="/ai-diagnostic" element={<AiDiagnostic />} />
          </Routes>
        </main>

        <Footer />
      </Router>
    </LanguageProvider>
  );
}

export default App;
